<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">疾病名称：</span>
					<el-input v-model="search_name" class="b_inp" placeholder="商品名称"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="diseaseNo"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="疾病名称"
					>
					</el-table-column>
					<el-table-column
						label="图标"
					>
						<template slot-scope="scope">
							<img :src="scope.row.icon" alt="" style="width: 48px;">
						</template>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增类型 -->
		<add 
			v-model="add_display" 
			@onSuccess="addSuccess"
		></add>
		<!-- 新增类型 end -->
		
		<!-- 修改类型 -->
		<update 
			v-model="update_display"
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改类型 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				
				search_name: '',
				search_startDate: '',
				search_endDate: '',
				search_disease: '',
				
				total: 0,
				currentPage: 1,
				tableData: [],
				
				add_display: false,
				
				update_display: false,
				update_data: {}
			}
		},
		methods: {
			/******************** @Events *************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 点击删除
			handleDeleteClick(msg) {
				const that = this;
				that.$confirm(
					'此操作将删除该疾病，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteDisease(msg.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					diseaseName: that.search_name,
					strat: that.search_startDate,
					end: that.search_endDate,
					typeChannel: 2
				};
				Api.findDiseasePageForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								diseaseNo:v.diseaseNo,
								name: v.diseaseName,
								icon: v.diseaseImg,
								time: v.createTs
							});
						});
						that.total = res.data.data.total;
						that.tableData = list;
						that.loading = false;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除疾病
			deleteDisease(id) {
				const that = this;
				that.loading = true;
				Api.deleteDiseaseForAppAndMall(id, {typeChannel: 2}).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style scoped>
</style>
